import { KeycloakStore } from './keycloakStore';

export const keycloakStore = new KeycloakStore();
